import { render } from "./DetilseProduct.vue?vue&type=template&id=7e076c48&scoped=true"
import script from "./DetilseProduct.vue?vue&type=script&lang=js"
export * from "./DetilseProduct.vue?vue&type=script&lang=js"

import "./DetilseProduct.vue?vue&type=style&index=0&id=7e076c48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e076c48"]])

export default __exports__